import { BookingsInsightsReport } from 'model/BookingsReport';

export interface BookingsInsightsReportState {
    insights: BookingsInsightsReport;
    status: BookingsInsightsReportStatus;
    loading: boolean;
}

export enum BookingsInsightsReportStatus {
    Initial,
    Getting,
    GettingSuccess,
    Error
}
